export default __webpack_public_path__ + "static/testimonial-emily-patel-f18469729e200ca79753a0cf93b3b75a.png";